import React from 'react';
import { components, OptionProps } from 'react-select';
import { ISelectOptions } from 'utils/models';

const CustomOption = (props: OptionProps<ISelectOptions, false>) => (
  <components.Option {...props}>
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <span>{props.label}</span>
      <span style={{ fontSize: 12, color: '#999' }}>
        {props.data.userType ?? props.data.value?.user_type}
      </span>
    </div>
  </components.Option>
);

export default CustomOption;
